'use client';

import { NaturalScrollCarousel } from '../../../../../../design-system/components/natural-scroll-carousel/NaturalScrollCarousel';
import { Destination } from '../../../../../../resources/destination/domain/types/destination';
import { UgcHighlight } from '../../../../../../resources/ugcHighlight/domain/types/ugcHighlight';
import { PickDomain } from '../../../../../../shared/utilities/types/PickDomain';
import { TravelerUgcCard } from '../Card/TravelerUgcCard';

type TravelersUgcCarouselProps = {
    travelersUgc: Array<
        PickDomain<
            UgcHighlight,
            'id' | 'segment' | 'username' | 'description' | 'pictures',
            {
                destination: PickDomain<Destination, 'id' | 'name' | 'slug' | 'preposition'>;
            }
        >
    >;
};

export function TravelersUgcCarousel({ travelersUgc }: TravelersUgcCarouselProps) {
    return (
        <NaturalScrollCarousel
            scrollSnapAlign="center"
            trackingInformation={{
                navClick: {
                    block: 'ugc',
                },
            }}
        >
            {travelersUgc.map((travelerUgc, index) => (
                <NaturalScrollCarousel.Slide key={travelerUgc.id}>
                    <TravelerUgcCard index={index} travelerUgc={travelerUgc} />
                </NaturalScrollCarousel.Slide>
            ))}
        </NaturalScrollCarousel>
    );
}
